import { toast } from "react-toastify";

const subscriptionAction = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  FETHING: "FETHING",

  success: messages => {
    messages !== "" &&
      toast.success(messages, {
        position: "top-right",
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    return {
      type: subscriptionAction.SUCCESS,
      resType: "success",
      messages: messages,
      show: true,
      isFetching: false
    };
  },

  error: messages => {
    messages !== "" &&
      toast.error(messages, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    return {
      type: subscriptionAction.ERROR,
      resType: "error",
      messages: messages,
      show: true,
      isFetching: false
    };
  },

  fetching: () => ({
    type: subscriptionAction.FETHING,
    isFetching: true
  })
};

export default subscriptionAction;